import { UUID } from '../../types/shared/UUID';
import { APIFactory } from 'ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from 'ui-toolkit/rest/axiosErrorHandler';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';
import {
  convertFromClientTitleResponseToClientTitleData,
  IClientTitleData,
  IClientTitleResponse,
} from 'types/clientPortal/IClientTitleData';

export const getClientTitleAsync = async (orderId: UUID): Promise<IClientTitleData> =>
  APIFactory(baseUrlService.ApiLocation)
    .get<IClientTitleResponse>(`/title_reports/v2/${orderId}`)
    .then((response) => convertFromClientTitleResponseToClientTitleData(response.data))
    .catch((e) => {
      if (e.response && e.response.status === 404) {
        return Promise.resolve({} as IClientTitleData);
      } else {
        return axiosErrorHandler(e);
      }
    });
